import { IState } from 'shared/store';

export const selectCompanyReliable = (state: IState) => {
  return state.offerData.company?.isReliable ?? false;
};
